import { ComponentChild } from 'preact'

import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

import { Mask } from '@bonniernews/dn-design-system-web/components/mask/mask.tsx'

export interface TeaserImageProps extends SharedProps {
  image: ComponentChild
  byline?: string
  mask?: 'quiz-mask'
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-image](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-image)
 * - Storybook: [TeaserImage](https://designsystem.dn.se/?path=/docs/section-subcomponents-teaserimage--docs)
 *
 * Image caption will never scale (forcePx is always true)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/teaser-image/teaser-image.scss'`
 */
export const TeaserImage = ({ image, byline, mask, classNames, attributes }: TeaserImageProps) => {
  const componentClassName = 'ds-teaser-image'

  const classes = formatClassString([componentClassName, mask ? `${componentClassName}--mask` : '', classNames])

  return (
    <figure className={classes} {...attributes}>
      {mask ? <Mask variant={mask} image={image} /> : image}
      {byline && <figcaption className={`${componentClassName}__byline`}>{byline}</figcaption>}
    </figure>
  )
}
